import React from 'react';
import { Provider } from 'react-redux';
import { createStore } from 'redux';
import ExperienceTabContainer from './ExperienceTab';
import rootReducer from '../../../reducers';
var store = createStore(rootReducer);
function ExperienceTab(props) {
  return /*#__PURE__*/React.createElement(Provider, {
    store: store
  }, /*#__PURE__*/React.createElement(ExperienceTabContainer, props));
}
export default ExperienceTab;